import subscribeToPush from "../../common/helpers/subscribeToPush";
import { playSound } from "../../common/helpers/soundHelpers";

const calendarValuesReceived = (store, eventDateId, actual, revised, isBetter) => {
    const pushDate = new Date().toISOString();
    const {
        config: { notificationSoundUrl, sendDataFnc },
        settings: { notificationSoundOn },
    } = store.getState();
    const eventDate = findEventDate(store, eventDateId);
    if (eventDate) {
        const newEventDate = {
            ...eventDate,
            actual: actual !== null ? actual : eventDate.actual,
            revised: revised !== null ? revised : eventDate.revised,
            isBetterThanExpected: actual !== null ? isBetter : eventDate.isBetterThanExpected,
        };

        updateEventDate(store, eventDateId, newEventDate);

        if (notificationSoundOn) playSound(notificationSoundUrl);

        if (actual !== null && sendDataFnc) {
            sendDataFnc({
                event: "calendar_push_release",
                event_date_id: eventDate.id,
                expected_date: eventDate.dateUtc,
                push_date: pushDate,
                actual: actual,
            });
        }
    }
};

const calendarDeviationReceived = (store, eventDateId, ratioDeviation) => {
    const eventDate = findEventDate(store, eventDateId);
    if (eventDate) {
        const newEventDate = {
            ...eventDate,
            ratioDeviation: ratioDeviation !== null ? ratioDeviation : eventDate.ratioDeviation,
        };
        updateEventDate(store, eventDateId, newEventDate);
    }
};

const calendarCrudValuesReceived = (store, eventDateId, eventDateChanges) => {
    const eventDate = findEventDate(store, eventDateId);
    if (eventDate && eventDateChanges?.consensus !== undefined) {
        const newEventDate = calendarCrudModifyConsensus(eventDate, eventDateChanges.consensus);
        updateEventDate(store, eventDateId, newEventDate);
    }
};

const calendarCrudModifyConsensus = (eventDate, consensus) => {
    const newEventDate = {
        ...eventDate,
        consensus: consensus,
    };
    return newEventDate;
};

const calendarSpeechScoreReceived = (store, eventDateId, score) => {
    const eventDate = findEventDate(store, eventDateId);
    if (eventDate) {
        const newEventDate = {
            ...eventDate,
            speech: {
                ...eventDate.speech,
                score: score !== null ? score : eventDate.speech.score,
            },
        };
        updateEventDate(store, eventDateId, newEventDate);
    }
};

const findEventDate = (store, eventDateId) => {
    const { eventDates } = store.getState();
    const eventDateIndex = eventDates.findIndex((ed) => ed.id.toLowerCase() === eventDateId.toLowerCase());
    if (eventDateIndex >= 0) {
        const eventDate = eventDates[eventDateIndex];
        return eventDate;
    }
    return null;
};

const updateEventDate = (store, eventDateId, updatedEventDate) => {
    const { eventDates } = store.getState();
    const eventDateIndex = eventDates.findIndex((ed) => ed.id.toLowerCase() === eventDateId.toLowerCase());
    let newEventDates = [...eventDates];
    newEventDates[eventDateIndex] = updatedEventDate;

    store.setState({ eventDates: newEventDates });
};

export const subscribeToCalendar = (store) => {
    const channels = [
        {
            name: "updatedValues",
            callback: (message) => {
                calendarValuesReceived(store, message.EventDateId, message.Actual, message.Revised, message.IsBetter, message.previousIsPreliminary);
            },
        },
        {
            name: "updatedDeviation",
            callback: (message) => {
                calendarDeviationReceived(store, message.EventDateId, message.RatioDeviation);
            },
        },
        {
            name: "updatedCrudValues",
            callback: (message) => {
                calendarCrudValuesReceived(store, message.EventDateId, message.Changes);
            },
        },
        {
            name: "speechScored",
            callback: (message) => {
                calendarSpeechScoreReceived(store, message.EventDateId, message.Score);
            },
        },
    ];

    try {
        subscribeToPush("calendarHub", channels);
    } catch (ex) {
        console.error("Could not connect to push.");
        console.log(ex);
    }
};
